<div class="d-flex flex-column" *ngFor="let notificationitem of newNotificationList">
    <app-notificationitem [notification]="notificationitem" ></app-notificationitem>
</div>
<div class="d-flex flex-column" *ngFor="let notificationitem of oldNotificationList">
    <app-notificationitem [notification]="notificationitem" ></app-notificationitem>
</div>

